import React from 'react';
import { FormTextField } from 'components/__v5__/FormTextField';
import { useInfoCollectionFormCtx } from 'pages/Main/QRScreens/hooks/useInfoCollectionFormCtx';

export const FirstName: React.FC = () => {
  const { control } = useInfoCollectionFormCtx();
  return (
    <FormTextField
      name="firstName"
      control={control}
      label="First Name*"
      placeholder="First Name*"
      showError
    />
  );
};
